import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};

export const ChapterLabel = ({ index, title, tone = "default" }) => {
  const color = tone === "cream" ? "rgba(253,252,248,0.7)" : "#7E9A6B";
  return (
    <div className="flex items-center gap-4">
      <span className="h-px w-12" style={{ backgroundColor: color }} />
      <span className="text-[0.7rem] uppercase tracking-[0.38em]" style={{ color }}>
        {index}{title ? ` · ${title}` : ""}
      </span>
    </div>
  );
};

// Slow parallax image. Container controls the height/rounding.
export const Parallax = ({ src, alt, className = "", strength = 7, imgClass = "" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={reduce ? undefined : { y }}
        className={`h-full w-full object-cover scale-[1.15] ${imgClass}`}
      />
    </div>
  );
};

export const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
